import React from 'react';
import '../styles.scss';
import { configData } from "../config.js";
import { fetchSigned } from "../shared/Utilities.js";
import CopyToClipboardButton from "../components/general/CopyToClipboardButton.js";

import {
  OwcTypography,
  OwcTable,
  OwcTableHeader,
  OwcTableHeaderCell,
  OwcTableRow,
  OwcTableCell,
  OwcTableBody,
  OwcButton,
  OwcSwitch,
  OwcProgressBar
} from '@one/react';

class BulkUpload extends React.Component {

   componentDidMount() {
    console.log("Current user:", this.props.userName);
 
  }
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      fileKey: Math.random(),
      parsedRows: [],
      csvMapping: [],
      error: null,
      comparing: false,
      uploading: false,
      successMessage: null,
      updateType: 'replace',
      previewData: [], 
      uploadIndex: 0
    };
  }

handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (!file) {
    this.setState({
      file: null,
      parsedRows: [],
      successMessage: null});
    return
  };

  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const text = e.target.result.replace(/^\uFEFF/, ''); // remove BOM
      const rows = text.split(/\r?\n/).filter(Boolean);

      if (rows.length < 2) throw new Error("CSV file is empty or has no data rows");

      // Detect separator: tab or comma
      const separator = rows[0].includes('\t') ? '\t' : ',';

      const headers = rows[0].toUpperCase().split(separator).map(h => h.trim());
      const agreementIndex = headers.indexOf('AGREEMENT ID');
      const accountIndex = headers.indexOf('ACCOUNT NO');

      if (agreementIndex === -1 || accountIndex === -1) {
        throw new Error('CSV must contain Agreement ID and Account No columns');
      }

      // Parse all rows, keep empty fields
      const parsedData = rows.slice(1)
        .map(row => {
          const cols = row.split(separator).map(c => c.trim());
          return {
            agreement_id: cols[agreementIndex] ? parseInt(cols[agreementIndex], 10) : null,
            account_no: cols[accountIndex] || ''
          };
        });

      this.setState({
        file,
        parsedRows: parsedData,
        csvMapping: parsedData,
        error: null,
        successMessage: null
      }, () => {
        console.log('CSV parsed and state updated:', this.state.csvMapping);
        this.props.onUnsavedChangesChange(true);
      });

    } catch (err) {
      this.setState({ error: err.message });
    }
  };

  reader.readAsText(file);
};


  handleCompare = () => {
  const payload = {
    user_name: this.props.userName,
    csvData: this.state.csvMapping,
    updateType: this.state.updateType
  };
  this.setState({ 
    comparing: true,
    previewData: [], 
  });

  console.log("Compare payload:", payload);
  fetchSigned(configData.BULK_LOAD_ACCOUNTS_API_URL + 'compare', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (!res.ok) throw new Error('Compare request failed');
      return res.json();
    })
    .then(data => {
      console.log("Compare result:", data);
      console.log("typeof data:", typeof data);
      if ((typeof data === 'string' || data instanceof String) && data.startsWith("ERROR")){
        this.setState({ 
          comparing: false,
          error: data,
          previewData: [], 
          uploadIndex: 0 });
      } else {
        //  store backend response in state to render table
        this.setState({ 
            comparing: false,
            error: null,
            previewData: data, 
            uploadIndex: 0 });
        
        this.props.onUnsavedChangesChange(true);
      }
    })
    .catch(error => {
      console.error("Compare error:", error);
      this.setState({ error: error.message || error });
    });
};


  handleSubmit = () => {
    this.setState({ uploading: true },
      () => {this.uploadNextAgreement()});   
  };

  uploadNextAgreement = () => {
    let index = this.state.uploadIndex;
    const payload = {
      user_name: this.props.userName,
      update_type: this.state.updateType,
      mappings: [this.state.previewData[index]]
    };
    console.log(`payload ${index}:`, payload)

    fetchSigned(configData.BULK_LOAD_ACCOUNTS_API_URL + 'store', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) throw new Error(`Upload failed at agreement ${index+1} of ${this.state.previewData.length}`);
        return res.json();
      })
      .then(() => {
        index = index + 1;
        if (index === this.state.previewData.length) {        
          console.log(`All Complete ${index} === ${this.state.previewData.length}`);
          this.setState({
          successMessage: 'Mappings uploaded successfully'
        }, ()=>{this.handleCancelClick(true)});
        } else {
          this.setState({
            uploadIndex: index
          }, () => {this.uploadNextAgreement()});
        }
      })
      .catch(error => {
        this.setState({ uploading: false, error });
      });
  };

  handleCancelClick = (retainSuccessMessage=false) => {
    this.setState({
      file: null,
      fileKey: Math.random(),
      parsedRows: [],
      csvMapping: [],
      error: null,
      comparing: false,
      uploading: false,
      successMessage: retainSuccessMessage?this.state.successMessage:null,
      updateType: 'replace',
      previewData: [], 
      uploadIndex: 0
    }, ()=>{this.props.onUnsavedChangesChange(false)});
  }

handleUpdateTypeChange = (event) => {
  const isAppend = event.detail; // boolean

  console.log('OwcSwitch value:', isAppend);

  this.setState({
    updateType: isAppend ? 'append' : 'replace',
    previewData: [],  // clear the preview data if the comparison type is changed
    successMessage: null,
  });
};


  renderAccounts(accounts) {
    if (!accounts || accounts.length === 0) return null;

    return (
      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
        {accounts.join(', ')}
      </div>
    );
  }

  renderPreviewTable(data) {
    if (!data || data.length === 0) return null;

    return (
      <>
      <OwcTypography>
        This file would make the following account mapping changes
      </OwcTypography>
      <OwcTable
        showRowExpanderColumn
      
        elevated
        verticalBorder
        size="medium"
        
        style={{ maxHeight: 'calc(100vh - 48px)', width: '100%' }}
      >
        <OwcTableHeader sticky shrink>
          <OwcTableHeaderCell resizable width={120} align="left">Agreement ID</OwcTableHeaderCell>
          <OwcTableHeaderCell resizable width="25%" align="left">Agreement Title</OwcTableHeaderCell>
          <OwcTableHeaderCell resizable width="15%" align="left">Accounts Added</OwcTableHeaderCell>
          <OwcTableHeaderCell resizable width="15%" align="left">Accounts Removed</OwcTableHeaderCell>
          <OwcTableHeaderCell resizable width="15%" align="left">Accounts Unchanged</OwcTableHeaderCell>
          <OwcTableHeaderCell resizable width="15%" align="left">Accounts Not Found</OwcTableHeaderCell>
        </OwcTableHeader>

        <OwcTableBody>
          {data.map(row => (
            <OwcTableRow expandable selectable key={row.agreement_id}>
              <OwcTableCell valign="middle">{row.agreement_id}</OwcTableCell>
              <OwcTableCell valign="middle">{row.agreement_title}</OwcTableCell>
              <OwcTableCell valign="middle">
                <div style={{display:"flex",alignItems:"center"}}>
                {row.accounts_added.length} 
                {row.accounts_added.length>0?
                  <CopyToClipboardButton id={row.agreement_id+"Added"} text={row.accounts_added.join('\n')}/>
                  :
                  <></>
                }
                </div>
              </OwcTableCell>
              <OwcTableCell valign="middle">
                <div style={{display:"flex",alignItems:"center"}}>
                {row.accounts_removed.length}
                {row.accounts_removed.length>0?
                  <CopyToClipboardButton id={row.agreement_id+"Removed"} text={row.accounts_removed.join('\n')}/>
                  :
                  <></>
                }
                </div>
              </OwcTableCell>
              <OwcTableCell valign="middle">
                <div style={{display:"flex",alignItems:"center"}}>
                {row.accounts_unchanged.length}
                {row.accounts_unchanged.length>0?
                  <CopyToClipboardButton id={row.agreement_id+"Unchanged"} text={row.accounts_unchanged.join('\n')}/>
                  :
                  <></>
                }
                </div>
              </OwcTableCell>
              <OwcTableCell valign="middle">
                <div style={{display:"flex",alignItems:"center"}}>
                {row.accounts_not_found.length}
                {row.accounts_not_found.length>0?
                  <CopyToClipboardButton id={row.agreement_id+"NotFound"} text={row.accounts_not_found.join('\n')}/>
                  :
                  <></>
                }
                </div>
              </OwcTableCell>

              <div slot="expanded" style={{ padding: 8, fontSize: 13, color: '#555' }}>
                Added: {row.accounts_added.join(', ')}<br/>
                Removed: {row.accounts_removed.join(', ')}<br/>
                Unchanged: {row.accounts_unchanged.join(', ')}<br/>
                Not Found: {row.accounts_not_found.join(', ')}
              </div>
            </OwcTableRow>
          ))}
        </OwcTableBody>
      </OwcTable>
      </>
    );
  }

  render() {
   return (
  <div className="tabContents" style={{ padding: '1em' }}>
  <OwcTypography variant="title6">
    Bulk Update Accounts Mapping
  </OwcTypography>

  <div
    style={{
      display: 'flex',
      marginTop: '1em',
      marginBottom: '1em',
    }}
  >
    {/* Left text */}
    <OwcTypography>
      Upload a file of agreement → account mappings
    </OwcTypography>

    {/* Right controls */}
    <div style={{ paddingLeft: '2rem' }}>
      <div style={{ paddingBottom: '1rem' }}>
        <input key={this.state.fileKey} 
          type="file"
          accept=".csv" 
          onChange={this.handleFileUpload} 
          disabled={this.state.uploading}/>
        {this.state.parsedRows.length > 0 && (
          <OwcTypography  style={{ paddingLeft: '2rem' }}>
            {this.state.parsedRows.length} records ready to upload
          </OwcTypography>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '1rem' }}>
        <OwcTypography>Replace Account Mapping</OwcTypography>
        <OwcSwitch
          checked={this.state.updateType === 'append'}
          disabled={this.state.uploading}
          onValueChange={this.handleUpdateTypeChange}
        >
          Append Account Mapping
        </OwcSwitch>
      </div>

      <OwcButton 
        onClick={this.handleCompare}
        disabled={this.state.uploading || this.state.comparing || this.state.parsedRows.length === 0}
        >Compare with existing agreements</OwcButton>
    </div>
  </div>

  <div>

  </div>
{this.state.error && (
  <OwcTypography style={{ color: '#b91c1c' }}>
    {typeof this.state.error === 'string'
      ? this.state.error
      : this.state.error.message}
  </OwcTypography>
)}
  {/* Table container - height now adjusts to content */}
  <div style={{ width: '100%', paddingTop: '1rem', overflow: 'auto' }}>
    {this.renderPreviewTable(this.state.previewData)}
  </div>

  {/* Submit button directly below the table */}


  <div style={{ display:"flex", flexDirection:"column",paddingTop:'1rem' }}>
    <table width="100%">
      <tbody>
        <tr>
          <td style={{verticalAlign:"top"}} align="left">
            <OwcButton elevated style={{ width: "fit-content" }}
                onclick={this.handleCancelClick}
                disabled={this.state.uploading}>
              Clear Unsaved Changes
            </OwcButton>
          </td>

          <td style={{verticalAlign:"top"}} align="right">
            <OwcButton
              disabled={this.state.uploading || this.state.comparing || this.state.previewData.length === 0}
              onClick={this.handleSubmit}
            >
              {this.state.uploading ? 'Saving...' : 'Save Changes'}
            </OwcButton>
          </td>
        </tr>
      </tbody>
    </table>
    {this.state.uploading?
      <OwcProgressBar
        mode="determinate"
        value={(100.0 * (this.state.uploadIndex + 1)) / this.state.previewData.length}
      >Saving Accounts to Agreement {this.state.uploadIndex+1} of {this.state.previewData.length}<br/>
      Do not close this tab or navigate away until complete.
      </OwcProgressBar>
      :
      <OwcTypography variant="title6" style={{ marginBottom: 8, textAlign: "right", color: "black" }}>
        {this.state.successMessage}
      </OwcTypography>
    }
  </div>

</div>
);

  }
}

export default BulkUpload;
